import React from 'react';
import FontAwesome from 'react-fontawesome';
import styled, { css } from 'styled-components';
import { textMuted } from '../modules/Styles';
var defaultProps = {
  hide: false,
  inline: false,
  size: 'large'
};
var DelaySpinner = styled(function (_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "spinner",
    spin: true
  }));
}).withConfig({
  displayName: "DelaySpinner",
  componentId: "sc-18ays3g-0"
})(["", " ", " ", " display:", ";"], textMuted(), function (props) {
  return props.inline ? css(["display:inline-block;"]) : css(["height:100%;margin:auto;padding-top:0.25em;text-align:center;width:100%;"]);
}, function (props) {
  return props.size === 'large' && css(["font-size:10em;"]);
}, function (props) {
  return props.hide ? 'none' : 'block';
});
DelaySpinner.defaultProps = defaultProps;
export default DelaySpinner;